import { render, staticRenderFns } from "./Passengers.vue?vue&type=template&id=3870716a&scoped=true"
import script from "./Passengers.vue?vue&type=script&lang=js"
export * from "./Passengers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3870716a",
  null
  
)

export default component.exports